// Logika „następny formularz pod utworzonym zadaniem” (spec/lista-zadan.md → Tworzenie zadań →
// Kolejne zadanie po Enter/Dodaj). Czysty moduł bez DOM — tests/unit/new_task_core_test.ts.

/** Gdzie po rerenderze otworzyć następny formularz: ten sam rodzic, pozycja tuż za utworzonym. */
export interface PendingForm {
  parentId: string | null;
  position: number;
}

/** Cel strefy widziany przez dopasowanie (podzbiór InsertTarget). */
export interface TargetLike {
  parentId: string | null;
  /** undefined = „na koniec dzieci” — wtedy liczy się siblingCount. */
  position: number | undefined;
  /** Liczba istniejących zadań na poziomie celu (po utworzeniu). */
  siblingCount: number;
}

export function pendingAfterCreate(parentId: string | null, createdPosition: number): PendingForm {
  return { parentId, position: createdPosition + 1 };
}

/** Cel pasuje, gdy wskazuje ten sam poziom i pozycję; cel „na koniec” pasuje, gdy utworzone było ostatnie. */
export function targetMatchesPending(t: TargetLike, p: PendingForm | null): boolean {
  if (!p) return false;
  return t.parentId === p.parentId && (t.position ?? t.siblingCount) === p.position;
}

/** Indeks pierwszego pasującego celu strefy albo undefined. */
export function autoOpenIndex(targets: TargetLike[], p: PendingForm | null): number | undefined {
  const i = targets.findIndex((t) => targetMatchesPending(t, p));
  return i >= 0 ? i : undefined;
}
